"use client";

import * as React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const standardsData = [{
  standard: "MIL-DTL-15024",
  covers: "Marking for identification plates, tags, and bands",
  output: "Phenolic & metal nameplates / data plates"
}, {
  standard: "MIL-P-15035",
  covers: "Phenolic plastic sheet/material for nameplates",
  output: "Engraving-grade phenolic nameplates"
}, {
  standard: "MIL-STD-130",
  covers: "Identification marking of U.S. military property (incl. IUID/UII)",
  output: "Direct part marking, serialized data matrix"
}, {
  standard: "AS9132",
  covers: "Aerospace data matrix quality for direct part marking",
  output: "DPM 2D data matrix marks"
}, {
  standard: "ISO/IEC 16022",
  covers: "2D data matrix symbology",
  output: "Data matrix code structure"
}];
export default function StandardsTable() {
  return <section id="standards-table" className="w-full py-16 md:py-24 bg-muted">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <div className="mb-10 space-y-4">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground tracking-tight">
            Which Marine and Aerospace Standards Does Evermark Mark To?
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl leading-relaxed">
            Evermark Industrial Solutions produces marking designed to align with the standards marine and aerospace programs specify, including:
          </p>
        </div>

        <div className="rounded-lg border border-border shadow-md bg-background overflow-hidden mb-10">
          <Table>
            <TableHeader className="bg-muted/50">
              <TableRow>
                <TableHead className="w-[200px] font-semibold text-foreground">Standard</TableHead>
                <TableHead className="font-semibold text-foreground">Covers</TableHead>
                <TableHead className="font-semibold text-foreground">Evermark Output</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {standardsData.map((item, i) => <TableRow key={i} data-index={i}>
                  <TableCell className="font-medium text-foreground whitespace-nowrap">
                    {item.standard}
                  </TableCell>
                  <TableCell className="text-muted-foreground">
                    {item.covers}
                  </TableCell>
                  <TableCell className="text-muted-foreground">
                    {item.output}
                  </TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </div>

        <div className="space-y-6 bg-background p-6 md:p-8 rounded-lg border border-border shadow-sm">
          <p className="text-sm md:text-base text-foreground leading-relaxed">
            Evermark Industrial Solutions produces marking designed to align with these standards when the part, material, content, and verification requirements are properly specified for the program. Evermark does not certify the part and is not the program's quality or design authority. Whether marking meets a contract or specification depends on the program's requirements, the customer's quality system, and the governing authority, so Evermark recommends confirming marking, material, grade, and verification requirements with the customer's quality engineer or a qualified specialist before a program begins.
          </p>
          <p className="text-sm text-muted-foreground italic border-l-2 border-primary pl-4">Mark verification and grading (e.g., to AS9132 / ISO/IEC TR 29158) when a program requires it.</p>
        </div>
      </div>
    </section>;
}